import { defineComponent } from 'vue';
export default defineComponent({
    props: {
        data: {
            type: Object,
            required: false,
            default: function () { return ({}); }
        }
    },
    computed: {
        imageUrl: function () {
            if (this.data && this.data.imageUrl) {
                if (this.data.imageUrl.startsWith('http')) {
                    return this.data.imageUrl + '?fm=webp&q=80&w=300&h=180';
                }
                return this.data.imageUrl;
            }
            return '/images/top/schedule/img.jpg';
        },
        imageSpUrl: function () {
            if (this.data && this.data.imageUrl) {
                if (this.data.imageUrl.startsWith('http')) {
                    return this.data.imageUrl + '?fm=webp&q=80&w=300&h=180';
                }
                return this.data.imageUrl;
            }
            return '';
        }
    },
    methods: {
        renderText: function (content) {
            if (Array.isArray(content)) {
                return content.map(function (text, index) { return "<span>" + text + "</span> " + (index < content.length - 1 ? '<br/>' : ''); }).join('');
            }
            return content;
        }
    }
});
